import React from 'react';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export const TypographyVariantStyles = {
  'body-large': 'text-sm font-body font-normal tracking-normal leading-6',
  'body-large-bold':
    'text-sm font-body font-semibold tracking-normal leading-6',
  'body-medium': 'text-xs font-body font-normal tracking-normal leading-4',
  'body-medium-bold':
    'text-xs font-body font-semibold tracking-normal leading-4',
  'body-small': 'text-[9px] font-body font-light tracking-normal leading-3',
  'body-small-bold':
    'text-[9px] font-body font-medium tracking-normal leading-3',
  'heading-1': 'text-2xl font-heading font-medium tracking-normal',
  'heading-2': 'text-lg font-heading font-medium tracking-normal leading-6',
  'heading-3': 'text-base font-heading font-normal tracking-normal',
  'heading-4': 'text-xs font-heading font-normal uppercase tracking-normal',
  'heading-5': 'text-xs font-heading font-normal tracking-normal',
  'ui-banner': 'text-xs font-body font-semibold tracking-normal',
  'ui-button-lg': 'text-[15px] font-body font-semibold tracking-normal',
  'ui-button-md': 'text-sm font-body font-semibold tracking-normal',
  'ui-input': 'text-sm font-body font-normal tracking-normal leading-7',
  'ui-nav-main':
    'text-[16px] font-heading font-[450px] leading-6 tracking-normal',
  'ui-nav-sm': 'text-[10px] font-body font-semibold uppercase tracking-normal',
  'ui-nav-sub': 'text-[14px] font-body font-medium tracking-normal',
} as const;

export type TypographyProps = {
  variant: keyof typeof TypographyVariantStyles;
  as:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'p'
    | 'th'
    | 'td'
    | 'span'
    | 'li';
  className?: string;
  children?: React.ReactNode;
};

const Typography: React.FC<TypographyProps> = (props) => {
  const { variant, className, children, ...other } = props;
  const c = twMerge(
    TypographyVariantStyles[variant],
    classNames({
      [className || '']: !!className,
    }),
  );

  return (
    <other.as className={c} {...other}>
      {children}
    </other.as>
  );
};

export default Typography;
